import { Modal } from "bootstrap";
const lcHelpers = {
    show: function(id) {
        const modalElement = document.getElementById(id);
        if (modalElement) {
            const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
            modal.show();
        }
    },
    hide: function(id) {
        const modalElement = document.getElementById(id);
        if (modalElement) {
            const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
            modal.hide();
        }
    }
};

window.lcHelpers = lcHelpers;
export { lcHelpers };
